export default __webpack_public_path__ + "static/media/carttable-infoicon.cfbef9f0.svg";